<template>
    <b-modal @ok="handleOk" @shown="focusInput" @hidden="resetModal" :okDisabled="disabled" :cancelDisabled="disabled" ref="modal" id="modal-add-product" title="Request Product" buttonSize="lg" okTitle="Request Product" centered>
        <template v-slot:modal-header="{ close }">
            <h4 class="h4 modal-title">
                <fa-icon :icon="['fas', 'plus-circle']" class="mr-2" />
                Request Product
            </h4>

            <button @click.prevent="close" type="button" class="close">
                <!-- <fa-icon :icon="['fas', 'times']" /> -->
                <i class="far fa-times"></i>
            </button>
        </template>

        <b-form @submit.stop.prevent="onFormSubmit" ref="form">
            <b-form-group label-for="url" label-size="lg">
                <template v-slot:label>
                    <fa-icon :icon="['fas', 'bookmark']" class="mr-1 text-muted" />
                    Product URL
                </template>
                <b-form-input @keyup.stop.enter="onFormSubmit" v-model="url" :class="{ 'is-invalid': hasError('url') }" type="text" size="lg" ref="url" id="url" trim required />
                <b-form-invalid-feedback v-cloak v-if="hasError('url')" :force-show="true">
                    {{ firstError('url') }}
                </b-form-invalid-feedback>
                <b-form-text v-cloak v-else>
                    The direct URL to the product page. Ex: https://www.walgreens.com/store/c/walgreens-earloop-style-face-mask/ID=prod6272763-product
                </b-form-text>
            </b-form-group>
        </b-form>

        <template v-slot:modal-footer="{ ok, cancel, hide }">
            <b-row class="action-buttons px-4 mx-0">
                <b-col cols="6">
                    <b-button @click.prevent="ok" :disabled="disabled" variant="primary" size="lg" block>
                        <span v-cloak v-show="loading">
                            <fa-icon :icon="['fas', 'circle-notch']" spin />
                        </span>
                        <span v-cloak v-show="!loading">
                            <fa-icon :icon="['fas', 'plus']" class="mr-1" />
                            Request Product
                        </span>
                    </b-button>
                </b-col>

                <b-col cols="6">
                    <b-button @click.prevent="hide" :disabled="disabled" variant="secondary" size="lg" block>
                        Cancel
                    </b-button>
                </b-col>
            </b-row>
        </template>
    </b-modal>
</template>

<script>
import { Errors } from 'form-backend-validation';

export default {
    data: () => ({
        url: "",
        loading: false,
        errors: new Errors()
    }),

    created() {},

    mounted() {},

    computed: {
        disabled() {
            return this.loading;
        }
    },

    methods: {
        hasError(field) {
            return this.errors.has(field);
        },

        firstError(field) {
            if (this.hasError(field)) {
                return this.errors.first(field);
            }
        },

        focusInput() {
            this.$refs.url.focus();
        },

        resetModal() {
            this.url = "";
            this.loading = false;
            this.errors = new Errors();
        },

        onFormSubmit() {
            this.addProduct();
        },

        handleOk($event) {
            $event.preventDefault();

            this.addProduct();
        },

        addProduct() {
            this.loading = true;

            axios.post('/api/listings', {
                url: this.url
            })
                .then(response => {
                    const product = response.data;

                    this.$emit('productAdded', product);

                    this.$nextTick(() => {
                        this.$refs.modal.hide();
                    });
                })
                .catch(err => {
                    console.error(err);
                    const response = err.response;
                    if (response.status === 422) {
                        this.errors = new Errors(response.data.errors);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
#modal-add-product {
    .modal-footer {
        display: block;
        padding: .5rem;
    }
}
</style>
